import { cva as e } from "class-variance-authority";
// src/design/charts/bar-chart/styles.ts
var t = {
	xs: {
		width: 300,
		height: 180
	},
	sm: {
		width: 400,
		height: 240
	},
	md: {
		width: 560,
		height: 320
	},
	lg: {
		width: 720,
		height: 400
	},
	xl: {
		width: 900,
		height: 500
	}
}, n = {
	xs: {
		top: 10,
		right: 10,
		bottom: 28,
		left: 34
	},
	sm: {
		top: 12,
		right: 14,
		bottom: 32,
		left: 40
	},
	md: {
		top: 16,
		right: 16,
		bottom: 36,
		left: 48
	},
	lg: {
		top: 20,
		right: 20,
		bottom: 40,
		left: 54
	},
	xl: {
		top: 24,
		right: 24,
		bottom: 44,
		left: 60
	}
}, r = {
	xs: 2,
	sm: 2,
	md: 3,
	lg: 4,
	xl: 5
}, i = e(["relative inline-flex flex-col"], {
	variants: { size: {
		xs: "w-[300px]",
		sm: "w-[400px]",
		md: "w-[560px]",
		lg: "w-[720px]",
		xl: "w-[900px]"
	} },
	defaultVariants: { size: "md" }
}), a = e(["text-muted-foreground"], {
	variants: { size: {
		xs: "text-2xs",
		sm: "text-2xs",
		md: "text-xs",
		lg: "text-xs",
		xl: "text-sm"
	} },
	defaultVariants: { size: "md" }
}), o = e(["stroke-border opacity-40"]), s = e(["flex flex-wrap items-center text-sm text-foreground"], {
	variants: { position: {
		top: "flex-row justify-center gap-4 mb-3",
		bottom: "flex-row justify-center gap-4 mt-3",
		right: "flex-col gap-2 ml-6"
	} },
	defaultVariants: { position: "bottom" }
}), c = e(["inline-flex items-center gap-2 text-muted-foreground cursor-pointer", "transition-opacity duration-normal"]), l = e(["w-2.5 h-2.5 rounded-full shrink-0"]), u = e([
	"absolute z-50 px-3 py-2 rounded-lg shadow-floating pointer-events-none",
	"bg-foreground text-background text-xs font-medium",
	"transition-opacity duration-fast"
]), d = e(["flex items-center gap-2"]);
function f(e) {
	let t = e?.size;
	return {
		root: (e) => i({
			size: t,
			...e
		}),
		axis: () => a({ size: t }),
		grid: () => o(),
		legend: (e) => s({ position: e }),
		legendItem: () => c(),
		legendDot: () => l(),
		tooltip: () => u(),
		tooltipRow: () => d()
	};
}
export { a as axisStyles, r as barRadiusMap, f as default, f as getStyles, o as gridStyles, l as legendDotStyles, c as legendItemStyles, s as legendStyles, n as marginMap, i as rootStyles, t as sizeMap, d as tooltipRowStyles, u as tooltipStyles };

//# sourceMappingURL=styles.js.map